// Custom components
import React, { useEffect, useState } from 'react';
import { IoSearchOutline } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { stockReports } from '../../../redux/actions/Report.action';
import { Button } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';

export default function ExpDateReport() {
  const dispatch = useDispatch();
  const reportData = useSelector((state) => state.report);
  console.log("reportData",reportData);
  

  const [formData, setFormData] = useState({
    search: '',
  });
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  const handleFormData = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    dispatch(stockReports());
  }, [formData]);

  const filteredData = reportData?.stockReport?.data?.data
    ?.filter((res) =>
      (res.partyName || '')
        .toLowerCase()
        .includes(formData.search.toLowerCase()),
    )
    .map((res) => ({
      ...res,
      batches: res.batches.filter((batch) => {
        const expDate = new Date(batch.expDate);
        const today = new Date();
        const oneMonthLater = new Date();
        oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);

        return expDate >= today && expDate <= oneMonthLater;
      }),
    }))
    .filter((res) => res.batches.length > 0); // Remove empty batch records

  useEffect(() => {
    setCurrentPage(0);
  }, [formData.search]);
  // Pagination Calculation
  const offset = currentPage * itemsPerPage;
  const currentData = filteredData?.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredData?.length / itemsPerPage) || 1;

  // Handle Page Change
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleDownload = () => {
    const excelData = [];
  
    filteredData?.forEach((item) => {
      item?.batches?.forEach((product) => {
        excelData.push({
          'Party Name': item?.partyName,
          'Code': product.productCode,
          'Product Name': product.productName,
          'Pack': product.salePack,
          'Batch No': product.batchNumber,
          'Exp. Date': product.expDate,
          'Qty': product.inRate,
          'Amount': product.inRate,
        });
      });
      excelData.push({});
    });
  
    console.log("excelData", excelData);
  
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Exp Product Report');
    XLSX.writeFile(workbook, 'Exp_Product_Report.xlsx');
  };
  

  return (
    <>
      <div className="mt-[100px]">
        <div className="d-flex items-center gap-4">
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 ms-auto">
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={formData.search}
              onChange={handleFormData}
              className="w-full outline-none"
              placeholder="Search..."
            />
          </div>
          <div>
            <Button 
              onClick={handleDownload}
              className="px-4 !bg-theme-dark border-0 text-white">
              Download
            </Button>
          </div>
        </div>
        <div className="text-end mt-4">
          Total Records:{' '}
          <span className="text-success border-b border-success">
            {filteredData?.length || 0}
          </span>
        </div>
      </div>

      <div className="mt-[50px] mb-4">
        <div className="row">
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Code
          </div>
          <div className="col-3 uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Product Name
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Pack
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Batch No.
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Exp. Date
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Qty
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            InRate
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Amount
          </div>
        </div>
        {filteredData?.length > 0 ? (
          filteredData?.map((res) => {
            return (
              <>
                <div className="row bg-[rgba(0,0,0,0.08)]">
                  <div className="col">{res.partyName}</div>
                </div>
                {res?.batches?.map((res) => {
                  return (
                    <div className="row bg-white mb-3 shadow-sm">
                      <div className="col px-[24px] py-[12px]">
                        {res.productCode}
                      </div>
                      <div className="col-3 px-[24px] py-[12px] uppercase">
                        {res.productName}
                      </div>
                      <div className="col px-[24px] py-[12px] uppercase">
                        {res.salePack}
                      </div>
                      <div className="col px-[24px] py-[12px] uppercase">
                        {res.batchNumber}
                      </div>
                      <div className="col px-[24px] py-[12px]">
                        {new Date(res.expDate).toLocaleDateString('en-GB', {
                          month: '2-digit',
                          year: 'numeric',
                        })}
                      </div>
                      <div className="col px-[24px] py-[12px]">{res.qty}</div>
                      <div className="col px-[24px] py-[12px]">
                        {res.inRate}
                      </div>
                      <div className="col px-[24px] py-[12px]">
                        {(res.qty * res.inRate).toFixed(2)}
                      </div>
                    </div>
                  );
                })}
              </>
            );
          })
        ) : (
          <div className="px-[24px] py-[12px] bg-[rgba(0,0,0,0.06)]">
            No any data
          </div>
        )}
      </div>
      {/* {currentData?.length > 0 && <>
        <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={handlePageChange}
        pageRangeDisplayed={10}
        pageCount={pageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
        forcePage={currentPage}
      />
      </>} */}
    </>
  );
}
